/* eslint-disable import/prefer-default-export */
import { TranslationFilterMessages, FilterMessages } from "../interfaces";

export const messages: TranslationFilterMessages = {
  [FilterMessages.filtersTitle]: "Filtros",
  [FilterMessages.noVehicles]: "Ningún vehículo en este momento",
  [FilterMessages.noNumDoc]: "No Integrados",
  [FilterMessages.noExternalId]: "No Integrados",
  [FilterMessages.noVehiclesLinkedToAPlant]: "Ningún vehículo vinculado a una planta",
  [FilterMessages.noVehiclesLinkedToARegional]: "Ningún vehículo vinculado a una regional",
  [FilterMessages.noVehiclesLinkedToAGroup]: "Ningún vehículo vinculado a un grupo",
  [FilterMessages.noConstruction]: "Ninguna obra en este momento",
  [FilterMessages.noTravelDocs]: "Ningún documento en este momento",
  [FilterMessages.noDrivers]: "Ningún conductor disponible",
  [FilterMessages.selectSomethingToFilter]: "Seleccione algo para filtrar",
  [FilterMessages.selectAtLeastOneVehicleType]: "Seleccione al menos un tipo de vehículo",
  [FilterMessages.concreteMixers]: "Hormigoneras",
  [FilterMessages.pumpTrucks]: "Camiones bomba",
  [FilterMessages.supportVehicles]: "Vehículos de apoyo",
  [FilterMessages.loaders]: "Cargadores",
  [FilterMessages.aggregateTrucks]: "Camiones agregado",
  [FilterMessages.siloTrucks]: "Camiones silo",
  [FilterMessages.clearFilters]: "Limpiar filtros",
  [FilterMessages.applyFilters]: "Aplicar filtros",
  [FilterMessages.filterInstructions]: "Filtre la información para obtener mejores resultados",
  [FilterMessages.optionUtcOffset]: "Desviación Horaria (UTC)",
  [FilterMessages.optionPumps]: "Camiones bomba",
  [FilterMessages.onGoing]: "Viaje en curso",
  [FilterMessages.recentActivity]: "Actividad reciente",
  [FilterMessages.ignitionOn]: "Encendido",
  [FilterMessages.ignitionOff]: "Apagado",

  [FilterMessages.optionVehicleTypes]: "Tipos de vehículo",
  [FilterMessages.optionNumDoc]: "Número de documento",
  [FilterMessages.optionExternalId]: "ID Externo",
  [FilterMessages.optionStartDate]: "Fecha inicial",
  [FilterMessages.optionEndDate]: "Fecha final",
  [FilterMessages.optionNumberStartValue]: "Valor inicial",
  [FilterMessages.optionNumberEndValue]: "Valor final",
  [FilterMessages.optionVehicles]: "Vehículos",
  [FilterMessages.optionPlants]: "Centrales",
  [FilterMessages.optionConstructions]: "Obras",
  [FilterMessages.optionTravelDocs]: "Documentos de viaje",
  [FilterMessages.optionClients]: "Clientes",
  [FilterMessages.optionAlertTypes]: "Tipos de alerta",
  [FilterMessages.optionDrivers]: "Conductores",
  [FilterMessages.optionRegionals]: "Regionales",
  [FilterMessages.optionGroups]: "Grupos",
  [FilterMessages.optionTravels]: "Viajes",
  [FilterMessages.optionReportType]: "Tipo de informe",
  [FilterMessages.optionVehicleStateTypes]: "Tipos de estado",
  [FilterMessages.optionVehicleStatus]: "Estado del vehículo",
  [FilterMessages.optionAverageSpeed]: "Velocidad promedio (km/h)",
  [FilterMessages.optionSpeed]: "Velocidad (km/h)",
  [FilterMessages.optionMinimumSpeed]: "Velocidad mínima (km/h)",
  [FilterMessages.optionMaximumSpeed]: "Velocidad máxima (km/h)",

  [FilterMessages.applicationVehicleHistory]: "Histórico de vehículos",
  [FilterMessages.applicationAlerts]: "Histórico de alertas",
  [FilterMessages.applicationTravelHistory]: "Histórico de viajes",
  [FilterMessages.applicationCoordinateHistory]: "Histórico de coordenadas",
  [FilterMessages.applicationVehicleStateHistory]: "Histórico de estados de vehículos",
  [FilterMessages.applicationVehicleAnalyticReport]: "Informe analítico de vehículos",
  [FilterMessages.applicationPumpTravelReport]: "Informe de viaje de bombas",
  [FilterMessages.applicationCanReport]: "Historial CAN",
  [FilterMessages.applicationOdometerHourmeterReport]: "Odómetro/Horómetro Total",
  [FilterMessages.applicationWaterAdditionsByTravel]: "Adiciones de agua por viaje",

  [FilterMessages.dateRangeLabel]: "Intervalo",
  [FilterMessages.filterOptions]: "Opciones de filtro",
  [FilterMessages.enterTextToFilter]: "Ingrese texto para filtrar",
  [FilterMessages.selectAll]: "Seleccionar todo",
  [FilterMessages.removeAll]: "Eliminar todo",
  [FilterMessages.selectAllFiltered]: "Seleccionar todas las opciones filtradas",
  [FilterMessages.removeAllFiltered]: "Eliminar todas las opciones filtradas",
  [FilterMessages.savedFilters]: "Filtros guardados",
  [FilterMessages.chooseFilterName]: "Elegir nombre del filtro",
  [FilterMessages.filterName]: "Nombre del filtro",
  [FilterMessages.saveNewFilter]: "Guardar selecciones como nuevo filtro",
  [FilterMessages.saveChanges]: "Guardar cambios en el filtro seleccionado",

  // Filter backend messages
  [FilterMessages.noFilterFound]: "No se encontró ningún filtro",
  [FilterMessages.readSuccess]: "Filtros devueltos con éxito",
  [FilterMessages.readError]: "Error al buscar filtros",
  [FilterMessages.createSuccess]: "Filtro creado con éxito",
  [FilterMessages.createError]: "Error al crear filtro",
  [FilterMessages.updateSuccess]: "Filtro actualizado con éxito",
  [FilterMessages.updateError]: "Error al actualizar filtro",
  [FilterMessages.deleteSuccess]: "Filtro eliminado con éxito",
  [FilterMessages.deleteError]: "Error al eliminar filtro"
};
